import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/JsonRenderComponents/signalCards/AssetEmaCandleChartCard";
/**
 * ⑤ EMA 蜡烛突破卡。 Figma：94103:23420
 */

import { useMemo } from "react";
import {
  deriveCandleChartSeries,
  formatEmaDisplay,
  MiniCandleChart,
} from "./miniCharts/MiniCandleChart";
import { SignalCardShell } from "./SignalCardShell";
import type {
  ChartAnnotationPoint,
  OhlcCandlePoint,
  SignalCardAssetProps,
} from "./types";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetEmaCandleChartCardProps extends SignalCardAssetProps {
  candles: OhlcCandlePoint[];
  annotation?: ChartAnnotationPoint;
}

export const AssetEmaCandleChartCard: React.FC<
  AssetEmaCandleChartCardProps
> = ({ candles, annotation, ...asset }) => {
  const { lastEma7, lastEma14 } = useMemo(
    () => deriveCandleChartSeries(candles),
    [candles],
  );

  return (
    <SignalCardShell {...asset}>
      <div className="flex flex-col gap-2">
        <p className="body_medium_s text-content_tertiary">
          {I18n.t("EMA (7, 14)")}
        </p>
        <div className="flex flex-wrap gap-1 body_medium_s">
          <span className="text-content_brand_primary">
            {I18n.t("EMA7:")}
            {formatEmaDisplay(lastEma7)}
          </span>
          <span className="text-border_accent3_solid">
            {I18n.t("EMA14:")}
            {formatEmaDisplay(lastEma14)}
          </span>
        </div>
        <MiniCandleChart candles={candles} annotation={annotation} />
      </div>
    </SignalCardShell>
  );
};
